import { render } from "./MutationContratPage.vue?vue&type=template&id=2978e1a9&ts=true"
import script from "./MutationContratPage.vue?vue&type=script&lang=ts"
export * from "./MutationContratPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__